import {Delete, Get, Post} from "../server";
import axios from "axios";

// 获取群聊红包记录列表
export function getRedEnvelope(params: any) {
  //Get方法用于向后台发送请求
  return Get("/admin/bill/groupRedEnvelope/groupRedEnvelopes", params);
}

// 获取群聊红包领取详情
export function getRedEnvelopeRecord(recordId: any) {
  //Get方法用于向后台发送请求
  return Get(`/admin/bill/groupRedEnvelope/grab/${recordId}`);
}

// 获取私聊红包记录列表
export function getPrivateRedEnvelope(params: any) {
  //Get方法用于向后台发送请求
  return Get("/admin/bill/privateRedEnvelope/privateRedEnvelopes", params);
}

// 获取转账列表
export function getTransferMoneyRecord(params: any) {
  //Get方法用于向后台发送请求
  return Get("/admin/bill/transferMoney/transferMoneys", params);
}


export function getGoldCoinDetails(params: any) {
  return Get("/admin/bill/goldCoinDetail/goldCoinDetails", params);
}

export function getSilverCoinDetails(params: any) {
  return Get("/admin/bill/silverCoinDetail/silverCoinDetails", params);
}

export function getActive(params: any) {
  return Get("/admin/active/", params);
}

export function deleteActive(activeId: any) {
  return axios({
    url: `/admin/active/${activeId}`,
    method: "delete",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
    },
    baseURL: process.env.REACT_APP_BASE_URL,
  });
}

export function updateActive({ activeId, params }: any) {
  return axios({
    url: `/admin/active/${activeId}`,
    method: "put",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
    },
    data: params,
    baseURL: process.env.REACT_APP_BASE_URL,
  });
}

export function addActive(params: any) {
  return axios({
    url: `/admin/active/`,
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
    },
    data: params,
    baseURL: process.env.REACT_APP_BASE_URL,
  });
}

export function chargeOptions() {
  return Get("/admin/charge/conf/amountList");
}
export function getDanzhuPayDetails(params: any) {
  return Get("/admin/bill/goldCoinDetail/danzhuPayDetails", params);
}

export function getDanzhuRecoveryDetails(params: any) {
  return Get("/admin/bill/silverCoinDetail/danzhuRecoveryDetails", params);
}

// 获取奖品列表
export function getPrizeList(params: any) {
  return Get("/admin/prize", params);
}

// 获取奖品记录
export function getdrawsList(params: any) {
  return Get("/admin/user/draws", params);
}

// 创建盲盒开奖期数
export function createdrawPeriod(data: any) {
  return Post("/admin/drawPeriod", data);
}

// 创建盲盒开奖期数
export function submitprize() {
  return Post("/admin/prize/sync");
}

export function drawPeriod(id:string | number) {
  return Delete(`/admin/drawPeriod/${id}`);
}
